import { render, staticRenderFns } from "./battery-level.vue?vue&type=template&id=2630b5c8"
import script from "./battery-level.vue?vue&type=script&lang=js"
export * from "./battery-level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports